import React, { useEffect, useRef, useState } from 'react';
import { TextField, Button, Switch, FormControlLabel, Box, Typography, Autocomplete, Radio, RadioGroup, FormControl, Avatar, Checkbox } from '@mui/material';
import { PlusCircle, ArrowLeft, ChevronLeft, User } from 'react-feather';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import Toastmessage from '../../components/Toast';
import { authApi, formauthApi } from '../../api/api';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid2';

const RequiredLabel = ({ children }) => (
    <>
      {children} <span style={{ color: 'red' }}>*</span>
    </>
  );
export default function CreateMember() {
    const fileInputRef = useRef(null);
    const [membername, setMemberName] = useState('');
    const [relationship, setRelationship] = useState(null);
    const [gender, setGender] = useState('');
    const [selectedYear, setSelectedYear] = useState(null);
    const [deathYear, setDeathYear] = useState(null);
    const [mother, setMother] = useState(null);
    const [father, setFather] = useState(null);
    const [spouse, setSpouse] = useState(null);
    const [tag, setTag] = useState(["trust"]);
    const [divorce, setDivorce] = useState(null);
    const [deceased, setDeceased] = useState(null);
    const [notes, setNotes] = useState(null);
    const [active, setActive] = useState(false);
    const [errors, setErrors] = useState({}); // State to hold validation errors
    const [imageURL, setImageURL] = useState(null);
    const [profile, setProfile] = useState(null);
     const [isLoading, setIsloading] = useState(false);



    const [isCheckboxChecked, setIsCheckboxChecked] = React.useState(false);

    const location = useLocation();
    const { treeId } = location.state || {};
    const { member } = location.state || {};

    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [motherOptions, setMotherOptions] = useState([]);

    const [fatherOptions, setFatherOptions] = useState([]);

    const [spouseOptions, setSpouseOptions] = useState([]);

    const [isparent, setIsparent] = useState(false);

    const handleChange = (event) => {
        setIsparent(event.target.checked);
    };

    const handleActiveChange = (event) => {
        setActive(event.target.checked);
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageURL(reader.result);
                setProfile(file); // Set the file object in formData
            };
            reader.readAsDataURL(file);
        }
    };

    // Generate an array of the last 150 years
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: 150 }, (_, i) => currentYear - i);




    useEffect(() => {
        if (treeId) {
            fetchfather(treeId);
            fetchmotherr(treeId);
        }
        if (member && treeId) {
            fetchmember(member, treeId)
        }
    }, [token, userID, treeId]); // Run effect when token or userID changes



    const fetchmember = async (member, treeId) => {
        const input_token = 'FAMILY_MEMBER_VIEW'; // Replace with your actual token
        const apiUrl = 'view_family_member'; // Replace with the actual API endpoint
    
        const dataInput = {
            login_user_id: userID,
            family_tree_id: treeId,
            family_member_id: member
        };
    
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);
            if (data && data.success) {
                const familyMemberDetail = data.family_member_detail || {};
    
                setMemberName(familyMemberDetail.name || '');
                setGender(familyMemberDetail.gender || '');
                setImageURL(familyMemberDetail.img || '');
                setProfile(familyMemberDetail.img || ''); // Set the file object in formData
                setMother(familyMemberDetail.mother);
                setFather(familyMemberDetail.father);
                setSpouse(familyMemberDetail.partner_detail ? familyMemberDetail.partner_detail[0] : '');
                setNotes(familyMemberDetail.notes || '');
                setActive(!!familyMemberDetail.status)
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }
    
        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };


    // Define fetchLocations separately to reuse it
    const fetchfather = async (treeId) => {
        const input_token = 'FATHER_LIST'; // Replace with your actual token
        const apiUrl = 'fathers_list'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            family_tree_id: treeId
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                // setRows(data.locations);
                setFatherOptions(data.fatherMembers)
                // setFilteredRows(data.locations); // Set filtered rows to the same data initially
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const fetchmotherr = async (treeId) => {
        const input_token = 'MOTHER_LIST'; // Replace with your actual token
        const apiUrl = 'mothers_list'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            family_tree_id: treeId
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                // setRows(data.locations);
                setMotherOptions(data.motherMembers)
                // setFilteredRows(data.locations); // Set filtered rows to the same data initially
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };




    const validateForm = () => {
        const newErrors = {};

        if (!membername.trim()) {
            newErrors.familyname = "Member name is required";
        }

        // if (!relationship) {
        //     newErrors.clientname = "Relationship required";
        // }

        // if (!gender) {
        //     newErrors.gender = "Gender required";
        // }

        // if (!selectedYear) {
        //     newErrors.selectedYear = "Birth year required";
        // }
        
        // if (deathYear && deathYear < selectedYear) {
        //     newErrors.deathYear = "Death year cannot be before birth year";
        // }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return; // Exit if validation fails
        }

        const formData = {
            membername,
            relationship: relationship ? relationship.relationship : '',
            gender,
            selectedYear: selectedYear ? selectedYear : '',
            deathYear,
            mother,
            father,
            spouse,
            tag,
            divorce,
            notes,
            active
        };


        const addmemberApi = async () => {
            setIsloading(true)
            const input_token = 'ADD_OR_EDIT_FAMILY_MEMBER';
            const apiUrl = 'add_family_member';

            // Create a FormData object
            const formDataToSend = new FormData();

            formDataToSend.append('id', member);
            formDataToSend.append('family_id', treeId);
            formDataToSend.append('relationship', relationship);
            formDataToSend.append('login_user_id', userID);
            formDataToSend.append('name', membername);
            formDataToSend.append('gender', 'Others');
            formDataToSend.append('notes', notes);
            formDataToSend.append('tags', ['trust']);
            formDataToSend.append('pids', null);
            // formDataToSend.append('mid', mother ? mother.id : null);
            formDataToSend.append('fid', father ? father.id : null);
            formDataToSend.append('is_deceased', 0);
            formDataToSend.append('trust', 1 );
            // Append form fields
            if (profile) {
                formDataToSend.append('img', profile);
            }
            try {
                const data = await formauthApi(input_token, formDataToSend, apiUrl, token, true);

                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate('/familytree'), 2000);
                } else if (data && data.message === 'Token has expired') {
                    setIsloading(false)
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false)
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false)
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false)
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };

        addmemberApi()
    };

    return (
        <Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Add New Trust
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/familytree"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to Family List
                </Button>
            </Box>

            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
                <form onSubmit={handleSubmit}>
                    <Box className="sub-header">
                        <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                            <Link to="/familytree" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                <ArrowLeft size={20} style={{ marginRight: '8px' }} /> {/* Add margin for spacing */}
                                Add New Trust
                            </Link>
                        </Typography>
                        {/* <FormControlLabel
                            control={<Switch checked={active} onChange={handleActiveChange} />}
                            label={
                                <Typography sx={{ color: active ? 'green' : 'red', fontWeight: 'bold' }}>
                                    Active : {active ? 'Yes' : 'No'}
                                </Typography>
                            }
                        /> */}
                    </Box>

                    <Grid container spacing={4} sx={{ mt: 2 }}>
                        {/* <Grid size={{ xs: 12, md: 12 }} display={'flex'} justifyContent={'end'}>
                            <FormControlLabel
                                control={<Checkbox checked={isparent} onChange={handleChange} />}
                                label="is parent"
                            />
                        </Grid> */}

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Trust Name</RequiredLabel></Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter the trust name"
                                variant="outlined"
                                value={membername}
                                onChange={(e) => setMemberName(e.target.value)}
                                error={!!errors.familyname}
                                helperText={errors.familyname} // Display error message
                                InputProps={{
                                    sx: {
                                        borderRadius: '8px',
                                    },
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Select Father</Typography>
                            <Autocomplete
                                options={fatherOptions}
                                getOptionLabel={(option) => `${option.name}`}
                                value={father}
                                disabled
                                onChange={(event, newValue) => setFather(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select father"
                                        variant="outlined"
                                        error={!!errors.father}
                                        helperText={errors.father} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid>
                    
                        <Grid size={{ xs: 12, md: 3 }}>
                            <Typography>Trust Logo</Typography>
                            <Box display="flex" flexDirection="row" alignItems="center" gap={3}>
                                <Avatar
                                    variant="rounded"
                                    src={imageURL || ""}
                                    sx={{ width: 100, height: 100, mb: 1 }}
                                />
                                <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
                                    <input
                                        type="file"
                                        accept="image/jpeg, image/png"
                                        style={{ display: 'none' }}
                                        ref={fileInputRef}
                                        onChange={handleFileUpload}
                                    />
                                    <Button sx={{ backgroundColor: 'var(--back-button)', color: "var(--back-color)", fontWeight: "600", padding: "10px 20px" }} onClick={handleButtonClick}>
                                        Upload Image
                                    </Button>
                                    <Typography variant="caption" sx={{ mt: 1 }}>
                                        JPG or PNG no larger than 5 MB
                                    </Typography>
                                    {/* Display image error */}
                                    {errors.profile_image && (
                                        <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                                            {errors.profile_image}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Grid>

                        {/* <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Select Mother</Typography>
                            <Autocomplete
                                options={motherOptions}
                                getOptionLabel={(option) => `${option.name}`}
                                value={mother}
                                onChange={(event, newValue) => setMother(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select mother"
                                        variant="outlined"
                                        error={!!errors.mother}
                                        helperText={errors.mother} // Display error message
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: { borderRadius: '8px' },
                                        }}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />
                        </Grid> */}

                        

                        <Grid size={{ xs: 12, md: 12 }}>
                            <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Additional Notes</Typography>
                            <TextField
                                fullWidth
                                placeholder="Enter additional notes"
                                variant="outlined"
                                multiline
                                rows={4} // Number of rows for the textarea
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                error={!!errors.notes}
                                helperText={errors.notes} // Display error message if any
                                InputProps={{
                                    sx: {
                                        borderRadius: '8px',
                                    },
                                }}
                            />
                        </Grid>


                        <Grid size={{ xs: 12, md: 12 }} sx={{ textAlign: 'center' }}>
                            <Button
                                type="submit"
                                variant="contained"
                                disabled={isLoading}
                                startIcon={<PlusCircle size={20} />}
                                className='btn-theme-button'
                            >
                                Update Trust
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Box>
    );
}
